<template>
    <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
        <template v-if="hasPlaceholder">
            <option value="">{{ placeholder }}</option>
        </template>
        <template v-for="item in items">
            <option :value="item.id" :selected="isSelectedItem(item.id)">{{ item.title }}</option>
        </template>
    </select>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-element-status'
            },
            name : {
                type : String,
                name : 'status'
            },
            value : {
                type : [String, Number],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            prependedOptions: {
                type: Array,
                default: null
            },
        },
        data() {
            return {
                items   : this.getItems()
            };
        },
        computed : {
            hasPlaceholder : function () {
                return this.placeholder !== '';
            }
        },
        methods : {
            getItems : function () {
                var statuses = [];

                if (this.prependedOptions) {
                    for (let key in this.prependedOptions) {
                        statuses.push({
                            id      : this.prependedOptions[key].id,
                            title   : this.prependedOptions[key].title
                        });
                    }
                }

                this.$helpers.statuses.forEach((function (status) {
                    statuses.push({
                        id      : status,
                        title   : this.$t('status.' + status)
                    });
                }).bind(this));
                
                // Add select option for those that are open, busy, not yet planned
                
                if(this.$store.getters.userIsAdmin == 1) {
                    statuses.push({
                        id: 'open,busy,notscheduled',
                        title: this.$t('status.open_busy_notscheduled')
                    })
                }
                
                return statuses;
            },
            onSelectItem : function (id) {
                this.$emit('input', id);
                this.$emit('change', this.getItemById(id));
            },
            onChangeItem : function (event) {
                this.onSelectItem(event.currentTarget.value);
            },
            isSelectedItem : function (id) {
                return this.value === id;
            },
            getItemById : function (id) {
                var output = null;

                this.items.forEach((function (item) {
                    if (item.id === id) {
                        output = item;
                    }
                }).bind(this));

                return output;
            }
        }
    }
</script>